export class Subsidiary {
    storeSubsidiaryId: string
    externalId: string
    label: string
    storeId: string
    isDefault: boolean
    localizations: Localization[]
    minAmountPurchase: number | null
    currencyCode: string
    slotSize: number | null
    express: boolean
    fallback: boolean
    deliveryCost: number | null
    serviceCost: number | null
    deleted: boolean
    countryCode: string
    departmentCode: string
    provinceCode: string
    districtCode: string
    districtName: string
    trackType: string
    trackName: string
    trackNumber: string
    inside: string
    reference: string
    latitude: number 
    longitude: number 
    approximateStartDeliveryTime: string | number
    approximateEndDeliveryTime: string | number
    isVisibleShop: boolean | undefined
    enabledHub?: boolean | undefined
    onEnabled?: boolean | undefined
    openHub?: string | undefined
    closeHub?: string | undefined
    hasInvoiceEnabled?: boolean | undefined
    hasCreditPayment?: boolean | undefined
    logisticProvider: string | null
    enableDeliveryCostInBilling: string | null



    

    constructor() {
        this.storeSubsidiaryId =  ''
        this.externalId =  ''
        this.label =  ''
        this.storeId =  ''
        this.isDefault =  false
        this.localizations =  []
        this.minAmountPurchase =  null
        this.currencyCode =  ''
        this.slotSize =  null
        this.express =  false
        this.fallback =  false
        this.deliveryCost =  null
        this.serviceCost =  null
        this.deleted =  false
        this.countryCode =  ''
        this.departmentCode =  ''
        this.provinceCode =  ''
        this.districtCode =  ''
        this.districtName =  ''
        this.trackType =  ''
        this.trackName =  ''
        this.trackNumber =  ''
        this.inside =  ''
        this.reference =  ''
        this.latitude =  0
        this.longitude =  0
        this.approximateStartDeliveryTime = ''
        this.approximateEndDeliveryTime = ''
        this.openHub = ''
        this.closeHub = ''
        this.logisticProvider = null;
        this.enableDeliveryCostInBilling = null;
    }

}

class Localization {
    storeSubsidiaryId!: string
    latitude!: number
    longitude!: number
}

export class SubsidiaryCode{
    name!: string
    code!: string
}

export class SubsidiaryListFilter {
    storeId!: string
    subsidiaryId!: string
    pageNumber!: number
    pageSize!: number
    name!: string
    sku!: string
    actualSearch!: string
}
